import { render } from "./coursemanagement.vue?vue&type=template&id=64e8ad7d&scoped=true"
import script from "./coursemanagement.vue?vue&type=script&lang=js"
export * from "./coursemanagement.vue?vue&type=script&lang=js"

import "./coursemanagement.vue?vue&type=style&index=0&id=64e8ad7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e8ad7d"]])

export default __exports__